module.exports = __webpack_public_path__ + "img/growth-icon.3b1286e5.svg";